import React, { useEffect, useState } from 'react'
import axios from 'axios'
import api from '../components/api'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'
import Table from 'react-bootstrap/Table'
import StatusValidacaoSecao from './StatusValidacaoSecao'

const Meta = (props) => {

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id

    var [hospClima_id, setHospClima_id] = useState()
    var [anoBase, setAnoBase] = useState()
    var [resultadoAnoBase, setResultadoAnoBase] = useState()
    var [anos, setAnos] = useState([])
    var [totalEmissoes, setTotalEmissoes] = useState()


    var [meta2050, setMeta2050] = useState('')
    var [meta2040, setMeta2040] = useState('')
    var [meta2030, setMeta2030] = useState('')
    var [meta2020, setMeta2020] = useState('')


    async function carregaDados() {

        

        if (!isNaN(adesao_institucional_id) && !isNaN(ano)) {

            await api.get(`desafioClimaPlanilha/${adesao_institucional_id}/${ano}`).then((result) => {

                //console.log(result.data)
                
                var data = result.data[0]
                setHospClima_id(data.hospClima_id)
    
                
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        


    }


    async function carregaDadosMeta() {

        await api.get(`desafioClimaMeta/${adesao_institucional_id}`).then((result) => {

            //console.log(result.data)
            var data = result.data[0]

            if (data) {

                setMeta2020(data.meta2020)
                setMeta2030(data.meta2030)
                setMeta2040(data.meta2040)
                setMeta2050(data.meta2050)
                setAnoBase(data.anoBase)

            }

        }).catch((err) => {

            console.log(err.response)

        })

    }



    function carregaAnos() {


        var year = moment().year();
        //console.log(year)
        
        

        var anosTemp = [];

        for (var i = year; i > 2006; i--) {
            anosTemp.push({ano: i});
        }

        //console.log(dias)

        setAnos(anosTemp.map((rs) => 
        
            <option value={rs.ano} key={rs.ano}>{rs.ano}</option>
        
        ))

    }


    function salvaMeta() {


        var dataPost = {

            meta2050: meta2050,
            meta2040: meta2040,
            meta2030: meta2030,
            meta2020: meta2020,
            anoBase: anoBase,
            adesao_institucional_id: adesao_institucional_id,

        }

        if (meta2050 == null || meta2050 == '' || meta2040 == null || meta2040 == '' || meta2030 == null || meta2030 == '' || meta2020 == null || meta2020 == '') {

            window.toastr.error('Por favor, informe todas as metas!')
            return false

        }

        if (anoBase == null || anoBase == '') {

            window.toastr.error('Por favor, informe o <b>ano base</b>!')
            return false

        }

        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'blue',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    
                    api.post(`desafioClimaMeta`, dataPost).then((result) => {

                        console.log(result.data)

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    async function emissaoAno() {

        if (anoBase != null) {

            if (!isNaN(anoBase) && !isNaN(adesao_institucional_id)) {

                var url = `desafioClimaEmissaoAno/${adesao_institucional_id}/${anoBase}`
    
                //console.log(url, '!!!')
    
                await api.get(url).then((result) => {
    
                    //console.log(result.data)
                    var data = result.data[0]
                    
                    if (data) {
    
                        setTotalEmissoes(data.totalEmissoes)
    
                    }
        
                }).catch((err) => {
        
                    console.log(err.response)
        
                })
    
            }

        }


    }


    useEffect(() => {

        emissaoAno()

    }, [anoBase])


    useEffect(() => {

        setHospClima_id('')
        carregaDados()
        carregaAnos()
        carregaDadosMeta()


    }, [ano, adesao_institucional_id])



    return (


        <div>


            <div style={{ display: isNaN(hospClima_id) ? 'block' : 'none'}} >

                Por favor, preencha os Dados de ações de liderança e resiliência primeiro!

            </div>

            
            <div style={{ display: !isNaN(hospClima_id) ? 'block' : 'none'}} >


                <div className="row">

                    <div className="col-md-8">
                        <div class="form-group" >
                            <label className="control-label">Qual o seu ano base (as emissões de GEE serão usadas como comparação para a redução nos anos seguintes)?</label>
                            <select className="form-control" value={anoBase} onChange={event => setAnoBase(event.target.value)} readOnly>
                                <option value="">[Selecione]</option>
                                {anos}
                            </select><br/>
                                

                        </div>
                    </div>

                    <div className="col-md-4">
                        <div class="form-group" >
                            <label className="control-label">Suas emissões de GEE no ano base foram:</label>
                            <input type="text" className="form-control" disabled />
                                

                        </div>
                    </div>

                    <div className="col-md-12">

                        <Table striped bordered hover>

                            <thead>

                                <tr style={{ backgroundColor: '#d2f3fa'}}>
                                    <th>
                                        <center>
                                        Ano Meta
                                        </center>
                                    </th>
                                    <th>
                                        Meta para a redução de emissões de GEE em comparação com o ano base
                                    </th>
                                </tr>
                                
                            </thead>
                            <tbody>

                                <tr>
                                    <td>
                                        <center>
                                        2050
                                        </center>
                                    </td>
                                    <td>
                                        <input className="form-control" type="number" pattern="^-?[0-9]\d*\.?\d*$" value={meta2050} onChange={event => setMeta2050(event.target.value)} readOnly />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <center>
                                        2040
                                        </center>
                                    </td>
                                    <td>
                                        <input className="form-control" type="number" pattern="^-?[0-9]\d*\.?\d*$" value={meta2040} onChange={event => setMeta2040(event.target.value)} readOnly />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <center>
                                        2030
                                        </center>
                                    </td>
                                    <td>
                                        <input className="form-control" type="number" pattern="^-?[0-9]\d*\.?\d*$"  value={meta2030} onChange={event => setMeta2030(event.target.value)} readOnly />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <center>
                                        2020
                                        </center>
                                    </td>
                                    <td>
                                        <input className="form-control" type="number" pattern="^-?[0-9]\d*\.?\d*$"  value={meta2020} onChange={event => setMeta2020(event.target.value)} readOnly />
                                    </td>
                                </tr>
                                

                            </tbody>

                        </Table>
                        
                    </div>
                    


                    </div>



            </div>


            <StatusValidacaoSecao desafio="Clima" secaoCampo="secaoMeta" nomeDesafio="Desafio Clima" formulario_id={hospClima_id} secao="Metas" adesao_institucional_id={adesao_institucional_id} ano={ano} />

        </div>

    )

}

export default Meta